export const errorMessages = {
    auditErrors : {
        noFileProvided: "File upload failed. No file provided.",
    }
}